import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Border = styled.span`
  width: 1px;
  height: 140px;
  background: #ECEDF2;
  margin-right: 40px;
  margin-left: 40px;
`

export const InformationStatus = styled.p`
  font-size: 12px;
  font-weight: 700;
  color: #696977;
  padding: 0 12px;
  width: 292px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  position: relative;

  cursor: pointer;
  & span {
    margin-left: 20px;

    &::before {
      content: "";
      display: inline-block;
      width: 14px;
      height: 14px;
      position: absolute;
      left: 10px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
      border-radius: 50%;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 17px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
      transform: translate(-50%,-50%);
    }

    &.open {
      &::before {
        border: 2.5px solid rgba(39,174,96,.25);
      }
  
      &:after {
        background-color: #27ae60;
      }
    }

    &.closed {
      &::before {
        border: 2.5px solid rgba(191, 13, 46, 0.25);
      }
  
      &:after {
        background-color: #BF0D2E;
      }
    }
  }
  .arrow {
    border: solid #696977;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: translateY(-3px) rotate(45deg);
    &--up {
      transform: rotate(-135deg);
      margin-top: 8px;
    }
  }

  &--active,
  &--open {
    border-radius: 4px 4px 0 0;
  }

  &--active {
    border-bottom: none;
  }
`
